import * as React from "react";
import { Chip, Tooltip } from "@mui/material";
import type { InvalidRecordsColumn } from "../../inventory-screen/dialogs/ImportResultsDialog";

export const importUsersResultsColumns: InvalidRecordsColumn[] = [
  {
    field: "index",
    label: <div>Row No.</div>,
    renderLogic: (row) => (
      <p className="text-neutral-90 font-normal">{row.index}</p>
    ),
  },
  {
    field: "name",
    label: <div>Name</div>,
    renderLogic: (row) => {
      const first = row.row.firstName ? String(row.row.firstName) : "";
      const last = row.row.lastName ? String(row.row.lastName) : "";
      const name = `${first} ${last}`.trim();
      return (
        <p className="text-neutral-90 font-normal">{name ? name : "N/A"}</p>
      );
    },
  },
  {
    field: "email",
    label: <div>Email</div>,
    renderLogic: (row) => (
      <p className="text-neutral-90 font-normal">
        {row.row.email ? String(row.row.email) : "N/A"}
      </p>
    ),
  },
  {
    field: "roleName",
    label: <div>Role</div>,
    renderLogic: (row) => (
      <p className="text-neutral-90 font-normal">
        {row.row.roleName ? String(row.row.roleName) : "N/A"}
      </p>
    ),
  },
  {
    field: "reason",
    label: <div>Error Reason</div>,
    renderLogic: (row) => (
      <Tooltip title={row.reason} arrow placement="top">
        <Chip
          label={row.reason}
          size="small"
          style={{
            backgroundColor: "#ffebee",
            color: "#d32f2f",
            fontSize: "12px",
            maxWidth: "300px",
            height: "auto",
            whiteSpace: "normal",
            wordBreak: "break-word",
            cursor: "default",
          }}
        />
      </Tooltip>
    ),
  },
];
